import { createSelector, createFeatureSelector } from "@ngrx/store";

import { NavigationState } from "@models/index";

export const navigationSelector =
  createFeatureSelector<NavigationState>("navigation");
export const getNavigationSelector = createSelector(
  navigationSelector,
  (state: NavigationState) => state
);
